import React, { useState } from 'react';
import { injectIntl } from 'react-intl';
import { getRemotedbUrl, i18nIntl, isNotEmpty } from '../../lib/ep.js';

import { MainButton } from '../builder/ActionButton';
import ActionLink from '../builder/ActionLink';
import ButtonCollection from '../builder/ButtonCollection.js';
import FloatingLayer from '../builder/FloatingLayer';
import Input from '../builder/Input';
import Model from '../builder/Model';
import SaveButton from '../builder/SaveButton';
import SectionTitle from '../builder/SectionTitle';
import SectionSubtitle from '../builder/SectionSubtitle';
import Select from '../builder/Select';

const OrganizerSelector = (props) => {
	return (
		<div>
			<Select
				name="id"
				model={props.model}
				change={(k, v) => props.change(k, v)}
				_class={{first:true}}
				label_props={props.label_props}
				values={props.values}
			>{props.children}</Select>

			{/* Agents Standard NO interact NOW with Easypromos, everything is Admin */}
			{(props.can_create) && (
				<ActionLink
					onClick={() => props.open_create_layer()}
				>Or create a new one</ActionLink>
			)}
		</div>
	)
};

const LabelSelector = (props) => {
	const i18n = (m, c) => i18nIntl(m, props.intl, c);
	const display_on = props?.display_on ?? 'inline';
	const type_default = props?.type ?? 1;
	const is_agent_admin = props?.is_agent_admin ?? false;
	const platforms = props?.platforms ?? [];

	const label_default = {
		id:props?.item_to_assign?.label_id ?? '',
		type:type_default,
		name:"",
	};

	const _organizers = (props?.organizers ?? []).filter((obj) => {
		const l = (obj.Label != undefined) ? obj.Label : obj;
		return (l.type == type_default) ? true : false;
	});

	const [ organizers, setOrganizers ] = useState(_organizers);
	const [ create, setCreate ] = useState(props?.create ?? false);
	const [ label, setLabel ] = useState(label_default);

	const changeLabel = (k, v) => {
		setLabel({ ...label, [k]:v });

		if(k == 'id' && v == 'new') {
			setCreate(true);
			return;
		}
		
		if(display_on == 'inline' && k == 'id') {
			const label_selected = organizers.find((obj) => (obj.id == v));
			setCreate(false);
			props.callback_set_label(label_selected);
		}
	};

	const createNewLabel = (cb) => {
		$.post(getRemotedbUrl(`/labels/create`), label, (result) => {
			if(result.status){
				setOrganizers([...organizers, result.label])
			}
			setLabelToItem(result.label, cb);
		}, 'JSON');
	};

	const assignLabel = (cb) => {
		if(label.id == undefined) return;

		const _label = organizers.find((obj) => {
			const l = obj?.Label ?? obj;
			return (l.id == label.id) ? true : false;
		});

		setLabelToItem(_label, cb);
	};

	const setLabelToItem = (_label, cb) => {
		const lab = _label?.Label ?? _label;

		if(props.item_to_assign != undefined) {
			$.post(getRemotedbUrl(`/labels/assign/`), {
				item:{
					...props.item_to_assign,
					label_id:lab.id,
				}
			}, (response) => {
				if(response.status) {
					let label_to_set = (response != undefined && response.status == 0) ? {} : _label;
					if(cb != undefined) cb(label_to_set);
				} else {
					if(cb != undefined) cb({});
				}

				if(!props.skip_refresh && response.force_refresh != undefined) window.location.reload();
			}, 'JSON');
		} else {
			if(cb != undefined) cb(_label);
		}

		const new_label = { ...label, id:lab.id };
		if(display_on != 'inline') new_label.name = lab.name;
		setLabel(new_label);
	};

	const finishProcessCallback = (l) => {
		setCreate(false);
		const _label = l ?? { ...label, name:'' };
		setLabel(_label);

		if(_label != undefined) {
			props.callback_set_label(_label);
			return;
		}
		if(props.onClose != undefined) props.onClose();
	};

	let avail_organizers = [{ k:'', v:`-- ${i18n("Select the organizing brand")} --`, order_name:"" }];
	organizers.map((_label) => {
		const l = _label?.Label ?? _label;
		if(label.type == l.type) avail_organizers.push({ k:l.id, v:l.name, order_name:l.name.toLowerCase() });
	});

	avail_organizers = avail_organizers.sort((a, b) => {
		if(a.order_name > b.order_name) return 1;
		if(a.order_name < b.order_name) return -1;
		return 0;
	})

	// To overlap the public CSS (from promotion) since in the actual page combines front and back elements:
	const styles = {
		'--field-color':'var(--main-text-color), 1',
		'--field-border-color':'var(--main-text-color), 0.2',
		'--field-border-radius':'5em',
	};

	if(create && is_agent_admin === false) {
		return (
			<FloatingLayer
				backButton={finishProcessCallback}
				_class={{ size:'small' }}
			>
				<div style={styles}>
					<SectionTitle _class={{ icon:'knk-drop', other:'redIcon' }}>Missing permissions</SectionTitle>

					<SectionSubtitle>You don't have the required permissions to create a new organizing brand.</SectionSubtitle>

					<SectionSubtitle>Please, ask the administrator of the account to create the organizing brand for your. Once created, you'll be able to come back and continue the process.</SectionSubtitle>

					<ButtonCollection in_floating={true}>
						<MainButton
							onClick={finishProcessCallback}
						>Close</MainButton>
					</ButtonCollection>
				</div>
			</FloatingLayer>
		)
	}

	if(display_on == 'inline' || create) {
		return (
			<div style={styles}>
				{(display_on == 'inline' && organizers.length > 0) && (
					<OrganizerSelector
						model={label}
						change={changeLabel}
						values={avail_organizers}
						open_create_layer={() => setCreate(true)}
						can_create={is_agent_admin}
						tooltip={props.tooltip}
						label_props={props.label_props}
					>{props.children}</OrganizerSelector>
				)}

				{(display_on == 'inline' && organizers.length == 0) && (
					<>
						<h3>{i18n("Create an organizing brand")}</h3>

						<p style={{ lineHeight:'1.2em', marginBlockStart:'0.2em' }}>{i18n("All promotions and giveaways are organized by a brand. As a first step, you should create an organizing brand for your giveaway, that will also help you arrange your promotions in your control panel.")} <ActionLink _href={`${window.zendesk_base_url}360028601832`} _target="_blank">More information</ActionLink></p>

						<ButtonCollection
							_class={{ other:'not_in_top' }}
						>
							<MainButton
								onClick={() => setCreate(true)}
							>Create an organizing brand</MainButton>
						</ButtonCollection>
					</>
				)}

				{(create) && (
					<FloatingLayer
						backButton={finishProcessCallback}
						_class={{ size:'small' }}
					>
						<div>
							<SectionTitle>Create an organizing brand</SectionTitle>

							<SectionSubtitle>All promotions and giveaways that you create should be linked to an organizing brand. You can have as many organizing brands as you wish in your account. They will help you arrange your promotions in your control panel.</SectionSubtitle>

							<Model
								model={label}
								change={changeLabel}
							>
								<Input
									name="name"
									max_length={40}
									_class={{ first:true }}
								>Write the name of the organizing brand</Input>
							</Model>

							<ButtonCollection
								in_floating={true}
							>
								<SaveButton
									disabled={((label?.name ?? '').length <= 2) ? true : false}
									onClick={(e, cb) => createNewLabel((label,cb) => finishProcessCallback(label))}
									type='create'
								>Create and assign</SaveButton>
							</ButtonCollection>
						</div>
					</FloatingLayer>
				)}
			</div>
		)
	}

	return (
		<FloatingLayer
			backButton={props.callback_set_label}
			_class={{ size:'small' }}
		>
			<div style={styles}>
				<SectionTitle>Which brand is organizing this promotion?</SectionTitle>

				<SectionSubtitle>All promotions and giveaways are organized by a brand. You need to assign an organizing brand from your account to the promotion.</SectionSubtitle>

				<OrganizerSelector
					model={label}
					change={changeLabel}
					values={avail_organizers}
					open_create_layer={() => setCreate(true)}
					can_create={is_agent_admin}
				/>

				{(platforms.length > 0) && (
					<Select
						value={props.platform_value}
						change={(k, v) => props.callback_set_platform(v)}
						values={platforms}
					>Template version</Select>
				)}

				<ButtonCollection in_floating={true}>
					<SaveButton
						disabled={!isNotEmpty(label, 'id') ? true : false}
						onClick={(e, cb) => assignLabel((label,cb) => finishProcessCallback(label))}
					>Continue</SaveButton>
				</ButtonCollection>
			</div>
		</FloatingLayer>
	)
};

export default injectIntl(LabelSelector);